<app-question-base [question]="question" [isFirstQuestion]="isFirstQuestion">
  <div class="file-upload-container lg:p-4">
    <kendo-upload
      [multiple]="false"
      (upload)="uploadEventHandler($event)"
      (remove)="removeEventHandler($event)"
      [attr.aria-label]="question.title"
    >
      <kendo-upload-messages
        dropFilesHere="{{ 'fileupload.dropzone.hint' | translate }}"
        select="{{ 'fileupload.select' | translate }}"
      >
      </kendo-upload-messages>
    </kendo-upload>

    <!-- File Status Display -->
    @if (control.value || file) {
      <div
        class="p-5"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        [attr.aria-label]="fileStatusMessage"
      >
        <button
          type="button"
          class="icon-button flex items-center justify-between file-status-display w-full text-left"
          (click)="removeFile()"
          [disabled]="uploadStatus === 'uploading'"
          [attr.aria-label]="'fileupload.removeinstruction' | translate"
          [attr.aria-describedby]="
            uploadStatus === 'error'
              ? 'file-error-' + question.id
              : uploadStatus === 'uploading'
                ? 'file-progress-' + question.id
                : undefined
          "
        >
          <div class="flex-1 min-w-0">
            <div class="text-sm break-all">
              {{ control.value || file?.name }}
            </div>
            @if (uploadStatus === "error" && errorMessage) {
              <div
                class="error-status-text text-xs mt-1"
                [id]="'file-error-' + question.id"
              >
                ✗ {{ errorMessage }}
              </div>
            }
          </div>
          <app-icon
            [name]="Icon.Trash"
            aria-hidden="true"
            class="flex-shrink-0"
          ></app-icon>
        </button>

        <!-- Progress Bar Below Button -->
        @if (uploadStatus === "uploading") {
          <div class="mt-3">
            <div class="upload-status-text text-xs mb-2">
              🔄 {{ "fileupload.uploading" | translate }}
            </div>
            <div class="progress-bar-container">
              <div
                class="progress-bar-fill"
                [style.width.%]="uploadProgress"
                role="progressbar"
                [attr.aria-valuenow]="uploadProgress"
                aria-valuemin="0"
                aria-valuemax="100"
                [attr.aria-label]="
                  'fileupload.uploadprogress'
                    | translate: { progress: uploadProgress }
                "
              ></div>
            </div>
            <div
              class="text-xs mt-1"
              [id]="'file-progress-' + question.id"
              aria-live="polite"
            >
              {{ uploadProgress }}%
            </div>
          </div>
        }
      </div>
    }

    @if (control.invalid && control.touched) {
      <app-validator
        [validator]="ValidatorType.RequiredSelect"
        [question]="question"
      ></app-validator>
    }
  </div>
  <p class="mt-6">
    {{ "question.fileupload.legaltext" | translate }}
  </p>
</app-question-base>
